// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"2f420159","447":"ba8841bf","557":"604a66a6","632":"3d1b8044","661":"ccdd97c8","967":"11f666ab"}[chunkId] + ".chunk.js";
};